function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M150.951 195.685C152.338 209.977 141.875 222.687 127.583 224.073L42.8873 232.288C33.3672 233.212 24.9011 226.243 23.9777 216.723C23.0543 207.203 30.0233 198.736 39.5434 197.813L150.118 187.088L150.951 195.685Z",
  fill: "#BAC1D1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.27 324.485C110.571 327.585 108.301 330.342 105.201 330.642C102.101 330.943 99.3439 328.674 99.0432 325.574L88.8034 220.004L100.03 218.915L110.27 324.485Z",
  fill: "#DEE7EE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.793 229.714C110.047 232.332 108.13 234.66 105.512 234.914L86.4943 236.759C83.8763 237.013 81.5481 235.096 81.2942 232.478C81.0402 229.86 82.9567 227.532 85.5747 227.278L104.593 225.434C107.211 225.18 109.539 227.096 109.793 229.714Z",
  fill: "#D1D8E5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.901 30.2589C134.022 21.1968 125.963 14.5631 116.901 15.4421C107.839 16.3211 101.205 24.3799 102.084 33.4419L117.547 192.858L150.363 189.674L134.901 30.2589Z",
  fill: "#DEE7EE"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.529 307.404C129.252 304.548 126.713 302.457 123.857 302.734L81.5199 306.84C78.6639 307.117 76.5732 309.657 76.8502 312.513L129.529 307.404Z",
  fill: "#DEE7EE"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.982 302.819L125.532 329.1C125.694 330.77 127.178 331.992 128.847 331.83C130.517 331.668 131.739 330.183 131.577 328.514L129.614 308.278C129.29 304.939 126.321 302.495 122.982 302.819Z",
  fill: "#DEE7EE"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.3957 306.755L84.9449 333.037C85.1068 334.706 83.8848 336.19 82.2155 336.352C80.5461 336.514 79.0616 335.292 78.8997 333.623L76.9369 313.387C76.613 310.048 79.057 307.079 82.3957 306.755Z",
  fill: "#DEE7EE"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.07352,
  ry: 6.06149,
  transform: "matrix(-0.995329 0.0965423 0.0965423 0.995329 81.5338 333.809)",
  fill: "#DEE7EE"
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.07352,
  ry: 6.0615,
  transform: "matrix(-0.995329 0.0965423 0.0965423 0.995329 128.167 329.286)",
  fill: "#DEE7EE"
});

var SvgChair = function SvgChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 187,
    height: 350,
    viewBox: "0 0 187 350",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chair.d20b5617.svg";
export { ForwardRef as ReactComponent };